import { createContext, useContext } from 'react';

/**
 * Provides the fully-scoped row source inside table form iterators.
 * For example, an input rendered in the first row of source="components" receives "components.0".
 */
const ScopedSourceContext = createContext('');

function useScopedSource(): string {
  return useContext(ScopedSourceContext);
}

export { ScopedSourceContext, useScopedSource };
